class AccordionEntry
    constructor: (el) ->
        @.$el = el
        if !@.$el.classList.contains 'accordion-entry--bound'
            @.$header = @.$el.querySelector '.accordion-entry__header'

            @.$el.classList.add 'accordion-entry--bound'
            @.InitEvents()
        return

    InitEvents: ->
        self = @
        @.$header.addEventListener 'click', (e) ->
            e.preventDefault()
            self.$el.classList.toggle 'accordion-entry--open'
            return
        return

BindAccordionEntries = ->
    document.querySelectorAll '.accordion-entry:not(.accordion-entry--bound)'
        .forEach (el) ->
            new AccordionEntry el
            return
    return

window.addEventListener 'bind-components', BindAccordionEntries